"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReferenceDialogSubtitle = exports.getReferenceDialogTitle = exports.ReferenceChoices = exports.ReferenceListTypes = void 0;
var ReferenceListTypes = (function () {
    function ReferenceListTypes() {
    }
    ReferenceListTypes.RISK = "risk";
    ReferenceListTypes.CONTROL = "control";
    ReferenceListTypes.ACTION = "action";
    return ReferenceListTypes;
}());
exports.ReferenceListTypes = ReferenceListTypes;
var ReferenceChoices = (function () {
    function ReferenceChoices() {
    }
    ReferenceChoices.getFromType = function (reference) {
        if (reference.from_risk)
            return ReferenceChoices.FROM_RISK;
        else if (reference.from_control)
            return ReferenceChoices.FROM_CONTROL;
        else if (reference.from_action)
            return ReferenceChoices.FROM_ACTION;
        else
            throw new Error("Unknown Reference from_ object");
    };
    ReferenceChoices.getFromLabel = function (reference) {
        var type_ = ReferenceChoices.getFromType(reference);
        switch (type_) {
            case ReferenceChoices.FROM_RISK:
                return gettext("risk");
            case ReferenceChoices.FROM_CONTROL:
                return gettext("control");
            case ReferenceChoices.FROM_ACTION:
                return gettext("action");
        }
    };
    ReferenceChoices.getToType = function (reference) {
        if (reference.to_risk)
            return ReferenceChoices.TO_RISK;
        else if (reference.to_control)
            return ReferenceChoices.TO_CONTROL;
        else if (reference.to_action)
            return ReferenceChoices.TO_ACTION;
        else if (reference.to_file)
            return ReferenceChoices.TO_FILE;
        else if (reference.to_link)
            return ReferenceChoices.TO_LINK;
        else
            throw new Error("Unknown Reference to_ object");
    };
    ReferenceChoices.getToLabel = function (reference) {
        var type_ = ReferenceChoices.getToType(reference);
        switch (type_) {
            case ReferenceChoices.TO_RISK:
                return gettext("risk");
            case ReferenceChoices.TO_CONTROL:
                return gettext("control");
            case ReferenceChoices.TO_ACTION:
                return gettext("action");
            case ReferenceChoices.TO_FILE:
                return gettext("file");
            case ReferenceChoices.TO_LINK:
                return gettext("link");
        }
    };
    ReferenceChoices.getToLabelNoTranslation = function (reference) {
        var type_ = ReferenceChoices.getToType(reference);
        switch (type_) {
            case ReferenceChoices.TO_RISK:
                return "risk";
            case ReferenceChoices.TO_CONTROL:
                return "control";
            case ReferenceChoices.TO_ACTION:
                return "action";
            case ReferenceChoices.TO_FILE:
                return "file";
            case ReferenceChoices.TO_LINK:
                return "link";
        }
    };
    ReferenceChoices.FROM_RISK = 10;
    ReferenceChoices.FROM_CONTROL = 20;
    ReferenceChoices.FROM_ACTION = 30;
    ReferenceChoices.TO_LINK = 10;
    ReferenceChoices.TO_RISK = 20;
    ReferenceChoices.TO_CONTROL = 30;
    ReferenceChoices.TO_ACTION = 40;
    ReferenceChoices.TO_FILE = 50;
    return ReferenceChoices;
}());
exports.ReferenceChoices = ReferenceChoices;
function getReferenceDialogTitle(reference) {
    var to_ = ReferenceChoices.getToType(reference);
    var from_ = ReferenceChoices.getFromType(reference);
    switch (from_) {
        case ReferenceChoices.FROM_RISK:
            switch (to_) {
                case ReferenceChoices.TO_RISK:
                    return gettext("Use a risk as a reference to this risk");
                case ReferenceChoices.TO_CONTROL:
                    return gettext("Use a control as a reference to this risk");
                case ReferenceChoices.TO_ACTION:
                    return gettext("Use an action as a reference to this risk");
                case ReferenceChoices.TO_FILE:
                    return gettext("Use a file as a reference to this risk");
                case ReferenceChoices.TO_LINK:
                    return gettext("Use a link as a reference to this risk");
            }
            break;
        case ReferenceChoices.FROM_CONTROL:
            switch (to_) {
                case ReferenceChoices.TO_RISK:
                    return gettext("Use a risk as a reference to this control");
                case ReferenceChoices.TO_CONTROL:
                    return gettext("Use a control as a reference to this control");
                case ReferenceChoices.TO_ACTION:
                    return gettext("Use an action as a reference to this control");
                case ReferenceChoices.TO_FILE:
                    return gettext("Use a file as a reference to this control");
                case ReferenceChoices.TO_LINK:
                    return gettext("Use a link as a reference to this control");
            }
            break;
        case ReferenceChoices.FROM_ACTION:
            switch (to_) {
                case ReferenceChoices.TO_RISK:
                    return gettext("Use a risk as a reference to this action");
                case ReferenceChoices.TO_CONTROL:
                    return gettext("Use a control as a reference to this action");
                case ReferenceChoices.TO_ACTION:
                    return gettext("Use an action as a reference to this action");
                case ReferenceChoices.TO_FILE:
                    return gettext("Use a file as a reference to this action");
                case ReferenceChoices.TO_LINK:
                    return gettext("Use a link as a reference to this action");
            }
            break;
    }
}
exports.getReferenceDialogTitle = getReferenceDialogTitle;
function getReferenceDialogSubtitle(reference) {
    var type_ = ReferenceChoices.getToType(reference);
    switch (type_) {
        case ReferenceChoices.TO_RISK:
            return gettext("Select a project to search and type in the name or number " +
                "of the risk you want to reference, and select it in the list.");
        case ReferenceChoices.TO_CONTROL:
            return gettext("Select a project to search and type in the name or number " +
                "of the control you want to reference, and select it in the list.");
        case ReferenceChoices.TO_ACTION:
            return gettext("Select a project to search and type in the name or number " +
                "of the action you want to reference, and select it in the list.");
    }
}
exports.getReferenceDialogSubtitle = getReferenceDialogSubtitle;
